import React from 'react'
import '../blockedLoginTab/BlockedLoginTab.css'
import { Link } from 'react-router-dom'

const BlockedLoginTab = () => {
  return (
    <div className='tabs-detail-sec blocked-login-tab'>
        <div className='blocked-login-box'>
             <div className='search-section-blocked'>
                <div className='search-box'>
                    <div className="search-container">
                        <form action="">
                            <div className='form-search-box'>
                                <button type="submit">
                                    <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.3418 19.25C16.1512 19.25 20.0501 15.3512 20.0501 10.5417C20.0501 5.7322 16.1512 1.83334 11.3418 1.83334C6.53228 1.83334 2.63342 5.7322 2.63342 10.5417C2.63342 15.3512 6.53228 19.25 11.3418 19.25Z" stroke="#787486" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M20.9668 20.1667L19.1334 18.3333" stroke="#787486" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                </button>
                                <input type="search" placeholder="Search.." name="" />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className='blocked-login-box-bottom'>
                <div className='block-box mb-md-3 mb-2 d-flex flex-wrap align-items-center'>
                    <div className='img-text-block d-flex align-items-center'>
                        <div className='img-blocked'>
                            <div className='img-block'></div>
                        </div>
                        <div className='text-blocked'>
                            <h2>iamchloe</h2>
                            <p>Chloe</p>
                        </div>
                    </div>
                    <div className='btn-block'>
                        <Link rel='stylesheet' to='/' className='btn btn-border'>Unblock</Link>
                    </div>
                </div>
                <div className='block-box mb-md-3 mb-2 d-flex flex-wrap align-items-center'>
                    <div className='img-text-block d-flex align-items-center'>
                        <div className='img-blocked'>
                            <div className='img-block'></div>
                        </div>
                        <div className='text-blocked'>
                            <h2>iamchloe</h2>
                            <p>Chloe</p>
                        </div>
                    </div>
                    <div className='btn-block'>
                        <Link rel='stylesheet' to='/' className='btn btn-border'>Unblock</Link>
                    </div>
                </div>
                <div className='block-box mb-md-3 mb-2 d-flex flex-wrap align-items-center'>
                    <div className='img-text-block d-flex align-items-center'>
                        <div className='img-blocked'>
                            <div className='img-block'></div>
                        </div>
                        <div className='text-blocked'>
                            <h2>iamchloe</h2>
                            <p>Chloe</p>
                        </div>
                    </div>
                    <div className='btn-block'>
                        <Link rel='stylesheet' to='/' className='btn btn-border'>Unblock</Link>
                    </div>
                </div>
                <div className='block-box mb-md-3 mb-2 d-flex flex-wrap align-items-center'>
                    <div className='img-text-block d-flex align-items-center'>
                        <div className='img-blocked'>
                            <div className='img-block'></div>
                        </div>
                        <div className='text-blocked'>
                            <h2>iamchloe</h2>
                            <p>Chloe</p>
                        </div>
                    </div>
                    <div className='btn-block'>
                        <Link rel='stylesheet' to='/' className='btn btn-border'>Unblock</Link>
                    </div>
                </div>
                <div className='block-box mb-md-3 mb-2 d-flex flex-wrap align-items-center'>
                    <div className='img-text-block d-flex align-items-center'>
                        <div className='img-blocked'>
                            <div className='img-block'></div>
                        </div>
                        <div className='text-blocked'>
                            <h2>iamchloe</h2>
                            <p>Chloe</p>
                        </div>
                    </div>
                    <div className='btn-block'>
                        <Link rel='stylesheet' to='/' className='btn btn-border'>Unblock</Link>
                    </div>
                </div>
                <div className='block-box mb-md-3 mb-2 d-flex flex-wrap align-items-center'>
                    <div className='img-text-block d-flex align-items-center'>
                        <div className='img-blocked'>
                            <div className='img-block'></div>
                        </div>
                        <div className='text-blocked'>
                            <h2>iamchloe</h2>
                            <p>Chloe</p>
                        </div>
                    </div>
                    <div className='btn-block'>
                        <Link rel='stylesheet' to='/' className='btn btn-border'>Unblock</Link>
                    </div>
                </div>
                <div className='block-box mb-md-3 mb-2 d-flex flex-wrap align-items-center'>
                    <div className='img-text-block d-flex align-items-center'>
                        <div className='img-blocked'>
                            <div className='img-block'></div>
                        </div>
                        <div className='text-blocked'>
                            <h2>iamchloe</h2>
                            <p>Chloe</p>
                        </div>
                    </div>
                    <div className='btn-block'>
                        <Link rel='stylesheet' to='/' className='btn btn-border'>Unblock</Link>
                    </div>
                </div>
                <div className='block-box mb-md-3 mb-2 d-flex flex-wrap align-items-center'>
                    <div className='img-text-block d-flex align-items-center'>
                        <div className='img-blocked'>
                            <div className='img-block'></div>
                        </div>
                        <div className='text-blocked'>
                            <h2>iamchloe</h2>
                            <p>Chloe</p>
                        </div>
                    </div>
                    <div className='btn-block'>
                        <Link rel='stylesheet' to='/' className='btn btn-border'>Unblock</Link>
                    </div>
                </div>
                <div className='block-box mb-md-3 mb-2 d-flex flex-wrap align-items-center'>
                    <div className='img-text-block d-flex align-items-center'>
                        <div className='img-blocked'>
                            <div className='img-block'></div>
                        </div>
                        <div className='text-blocked'>
                            <h2>iamchloe</h2>
                            <p>Chloe</p>
                        </div>
                    </div>
                    <div className='btn-block'>
                        <Link rel='stylesheet' to='/' className='btn btn-border'>Unblock</Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default BlockedLoginTab
